import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// import "../SuggList.css";
import "../SuggList/SuggList.css"
import ProductCard from "../ProductCard/ProductCard";

export default function SuggList() {
  const [products, setProducts] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const stored = localStorage.getItem("suggestions");
    if (stored) {
      setProducts(JSON.parse(stored));
    }
  }, []);

  return (
    <div className="container mt-5 min-vh-100 pt-5">
      <h3 className="fw-bold mb-4 mt-5 pt-5">كل الاقتراحات</h3>
       <ProductCard/>
      {products.length === 0 ? (
        <p className="text-center text-muted">
          لا توجد اقتراحات حاليًا
        </p>
      ) : (
        <div className="row">
            
          {products.map((item) => (
            <div className="col-md-3 col-sm-6 mb-4" key={item.id}>
              <div
                className="product-card"
                onClick={() =>
                  navigate(`/advertisementdetails/${item.id}`)
                }
              >
                <img
                  src={item.images?.[0] || "/placeholder.png"}
                  alt=""
                  style={{
                    width: "100%",
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: "12px",
                  }}
                />
                <h6 className="mt-3">{item.name}</h6>
                <p className="price">
                  {(item.priceAfterDiscount > 0
                    ? item.priceAfterDiscount
                    : item.price) +
                    " " +
                    item.currencyType}
                </p>
              </div>
           
            </div>
            
          ))}
          
        </div>
      )}
    </div>
  );
}
